/* =================================================================
   Flozy Design System — MUI typography
   Inter throughout. Quiet headers per Flozy README:
   page-title is 24/32 Bold; section-title 18/28 SemiBold.
   ================================================================= */

const FONT_STACK = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

const typography = {
	fontFamily: FONT_STACK,
	// Display sizes (-2% tracking)
	h1: {
		fontFamily: FONT_STACK,
		fontSize: 30,
		lineHeight: '38px',
		fontWeight: 600,
		letterSpacing: '-0.02em',
	},
	h2: {
		fontFamily: FONT_STACK,
		fontSize: 24, // Flozy page-title
		lineHeight: '32px',
		fontWeight: 700,
		letterSpacing: '-0.01em',
	},
	h3: {
		fontFamily: FONT_STACK,
		fontSize: 20,
		lineHeight: '30px',
		fontWeight: 600,
	},
	h4: {
		fontFamily: FONT_STACK,
		fontSize: 18, // Flozy section-title
		lineHeight: '28px',
		fontWeight: 600,
	},
	h5: {
		fontFamily: FONT_STACK,
		fontSize: 16, // Flozy card-title
		lineHeight: '24px',
		fontWeight: 700,
	},
	h6: {
		fontFamily: FONT_STACK,
		fontSize: 14,
		lineHeight: '20px',
		fontWeight: 600,
	},
	subtitle1: {
		fontFamily: FONT_STACK,
		fontSize: 14,
		lineHeight: '20px',
		fontWeight: 500,
	},
	subtitle2: {
		fontFamily: FONT_STACK,
		fontSize: 12,
		lineHeight: '18px',
		fontWeight: 500,
	},
	body1: {
		fontFamily: FONT_STACK,
		fontSize: 14, // workhorse
		lineHeight: '20px',
		fontWeight: 400,
	},
	body2: {
		fontFamily: FONT_STACK,
		fontSize: 12,
		lineHeight: '18px',
		fontWeight: 400,
	},
	button: {
		fontFamily: FONT_STACK,
		fontSize: 14, // Flozy buttons are 14/20 Medium
		lineHeight: '20px',
		fontWeight: 500,
		textTransform: 'none',
		letterSpacing: '0em',
	},
	caption: {
		fontFamily: FONT_STACK,
		fontSize: 12,
		lineHeight: '18px',
		fontWeight: 500,
		letterSpacing: '0.01em',
	},
	overline: {
		fontFamily: FONT_STACK,
		fontSize: 12,
		fontWeight: 500,
		letterSpacing: '0.04em',
		textTransform: 'uppercase',
		lineHeight: '18px',
		display: 'block',
	},
};

export default typography;
